// extracted by mini-css-extract-plugin
export var gif = "_lh-0";